import { useEffect } from 'react';

// Both layouts pin the nav to the left edge with a runtime-variable width: ODP v2 renders an
// <aside> that collapses 220<->64, classic Backstage renders a fixed drawer.
// Generated class names are minified in production builds, so match on stable attributes only.
// The classic sidebar root is a zero-width fixed box; its child drawer carries the width.
const NAV_SELECTORS = ['[data-odp-nav]', '[data-testid="sidebar-root"] > *'];
const NAV_WIDTH_VARIABLE = '--odp-ai-chat-nav-width';

// The widget assigns its `sidebar` attribute straight to the fullscreen panel's `left`. Handing it
// a var() keeps the offset live, so collapsing the nav while fullscreen reflows the panel.
export const AI_CHAT_NAV_OFFSET = `var(${NAV_WIDTH_VARIABLE}, 0px)`;

function findNav(): HTMLElement | null {
  for (const selector of NAV_SELECTORS) {
    const nav = document.querySelector<HTMLElement>(selector);
    if (nav) {
      return nav;
    }
  }
  return null;
}

// `key` re-runs the lookup when the layout may have swapped (theme change navigates to /home).
export function usePublishAppNavWidth(key: string): void {
  useEffect(() => {
    const nav = findNav();
    if (!nav) {
      document.documentElement.style.setProperty(NAV_WIDTH_VARIABLE, '0px');
      return undefined;
    }

    const publish = () =>
      document.documentElement.style.setProperty(
        NAV_WIDTH_VARIABLE,
        `${nav.offsetWidth}px`,
      );

    publish();
    const observer = new ResizeObserver(publish);
    observer.observe(nav);
    return () => observer.disconnect();
  }, [key]);
}
